import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';

/**
 * Delete multiple Users by their External IDs
 * @param externalIds Array of External IDs of the users to delete
 * @returns A data object indicating success
 */
export function deleteUsersBulk(this: unknown, externalIds: string[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).usersUrl}/bulk`, {
        method: 'DELETE',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify({
          externalIds,
        }),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.object({
          success: z.boolean(),
        }),
      })
    )
  );
}
